/** 투자 상태(코드: @d3/interface InvestStatusOption) */
export type InvestStatus =
  | 'None'
  | 'PartialExit'
  | 'CompleteExit'
  | 'Shutdown'
  | 'PreShutdown'
  | 'CompleteImpairment'
  | 'PartialImpairment';

export const INVEST_STATUS_BADGE_TYPES = [
  'complete-exit',
  'partial-exit',
  'complete-impairment',
  'partial-impairment',
  'shutdown',
  'pre-shutdown',
] as const;

/** `InvestStatusBadge` 의 type(Figma variant 이름과 같다) */
export type InvestStatusBadgeType = (typeof INVEST_STATUS_BADGE_TYPES)[number];

const INVEST_STATUS_TO_BADGE: Record<InvestStatus, InvestStatusBadgeType | null> = {
  None: null,
  CompleteExit: 'complete-exit',
  PartialExit: 'partial-exit',
  CompleteImpairment: 'complete-impairment',
  PartialImpairment: 'partial-impairment',
  Shutdown: 'shutdown',
  PreShutdown: 'pre-shutdown',
};

/** 배지를 그리지 않는 값(None · 없음)은 null — 부르는 쪽이 그리지 않는다 */
export function toInvestStatusBadgeType(
  status: InvestStatus | null | undefined,
): InvestStatusBadgeType | null {
  return status ? INVEST_STATUS_TO_BADGE[status] : null;
}
